import React from "react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const router = useNavigate();
  return (
    <div className="absolute items-center justify-center mb-16 text-center -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
      <span className="bg-gradient-to-b from-foreground to-transparent bg-clip-text text-[10rem] font-extrabold leading-none text-transparent">
        Erreur 404
      </span>
       <p>Désolé, la page que vous recherchez n'existe pas</p>
      <div className="flex justify-center gap-2 mt-8">
        <a href="/">
          <Button
            variant="default"
            size="lg"
            className="bg-black hover:bg-black"
          >
            Accueil
          </Button>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
